<template>
  <section class="estate-list">
    <div class="estate-list__inner">
      <div class="estate-list__head">
        <!--   <pre>{{ meta.total }}</pre> -->
        <TransitionFade mode="out-in">
          <div v-if="meta.total === 0"
            class="estate-list__search-result">
            По вашему запросу ничего не найдено
          </div>
          <div v-else-if="String(meta.total).slice(-1) === '1' && meta.total !== 11"
            class="estate-list__search-result">
            Найден {{ meta.total }} объект
          </div>
          <div v-else-if="String(meta.total).slice(-1) === '2' && meta.total !== 12"
            class="estate-list__search-result">
            Найдено {{ meta.total }} объекта
          </div>
          <div v-else-if="String(meta.total).slice(-1) === '3' && meta.total !== 13"
            class="estate-list__search-result">
            Найдено {{ meta.total }} объекта
          </div>
          <div v-else-if="String(meta.total).slice(-1) === '4' && meta.total !== 14"
            class="estate-list__search-result">
            Найдено {{ meta.total }} объекта
          </div>
          <div v-else-if="meta.total === 7"
            class="estate-list__search-result">
            Найдено {{ meta.total }} объектов
          </div>

          <div v-else-if="!meta.total"
            class="estate-list__search-result">
            &nbsp;
          </div>

          <div v-else
            class="estate-list__search-result">
            Найдено {{ meta.total }} объектов
          </div>
        </TransitionFade>

        <div class="estate-list__head-actions">
          <AppSorting :options="sortingList"
            class="estate-list__sorting"
            @sorting="onSorting" />

          <AppToggle class="estate-list__toggle-map"
            label="Показать на карте"
            @change="onMapToggle" 
            like-icon="location"
          />
        </div>
      </div>
      <div class="estate-list__body">
        <ul class="estate-list__list">
          <li v-for="(estateItem, index) in estateList"
            :key="index"
            class="estate-list__item">
            <EstateCard v-if="isSlider"
              :key="cardKey"
              :is-small="true"
              :card="estateItem" />
            <EstateCardFull v-else
              :card="estateItem" />
          </li>
        </ul>
      </div>
      <div class="estate-list__bottom">
        <AppButton 
          v-if="meta.current_page < meta.last_page"
          @click="onShowMore"
          class="estate-list__btn"
        >
          Показать еще
        </AppButton>
        <PagePagination v-if="Math.ceil(meta.total / meta.per_page) !== 1"
          class="estate-list__pagination"
          :total-pages="Math.ceil(meta.total / meta.per_page)"
          :total="+meta.total"
          :per-page="+meta.per_page"
          :current-page="+meta.current_page"
          @pagechanged="onPageChange" />
      </div>
    </div>
  </section>
</template>

<script>
import AppButton from "@/components/ui/AppButton.vue";
import AppToggle from "@/components/ui/AppToggle.vue";
import AppSorting from "@/components/ui/AppSorting.vue";
import EstateCard from "@/components/EstateCard.vue";
import EstateCardFull from "@/components/EstateCardFull.vue";
import PagePagination from "@/components/ui/PagePagination.vue";
import { mapActions } from "pinia";
import { useFilterStore } from "@/store/filters/filterStore.js";
import { setParamsInUrl } from "@/plugins/helpers.js";

export default {
  name: "EstateList",
  components: { EstateCard, EstateCardFull, PagePagination, AppButton, AppToggle, AppSorting },

  props: {
    estateList: {
      type: [Array, Object],
      default: () => [],
    },
    meta: {
      type: Object,
      default: () => { },
    },
    isSlider: {
      type: Boolean,
      default: true
    }
  },
  emits: ["page-changed", "map-toggle", "show-more"],

  data() {
    return {
      currentPage: 1,
      sortingList: [
        "По умолчанию",
        "Цена по возрастанию",
        "Цена по убыванию",
        "Площадь по возрастанию",
        "Площадь по убыванию",
      ],
      searchText: {
        find: "Найдено",
        find2: "Найден",
        object: "Объектов",
        object2: "Объект",
      },
      cardKey: 0,
    };
  },

  methods: {
    ...mapActions(useFilterStore, ["setSort", "returnRequiredParams"]),
    onPageChange(page) {
      this.$emit("page-changed", page);

      this.$nextTick(() => {
        this.cardKey += 1;
      });
    },

    onShowMore() {
      this.$emit("show-more");
    },

    onMapToggle(event) {
      this.$emit("map-toggle", event);
    },

    async onSorting(payload) {
      this.setSort(payload);
      await setParamsInUrl(this, this.$route.query, {
        sortBy: payload[0],
        orderBy: payload[1],
      });
      emitter.emit("load-with-params");
      this.cardKey += 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.estate-list {
  $that: &;

  overflow: hidden;
  padding: 0 0 96px;
  position: relative;

  @include desktop {
    padding: 0 0 50px;
  }

  @include laptop {
    padding: 0 0 50px;
  }

  &__inner {
    @extend %container;
    padding-top: 60px;

    @include phone {
      padding-top: 0;
    }
  }

  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 24px;
    position: relative;
    // z-index: 99;

    @include laptop {
      justify-content: space-between;
      padding-bottom: 20px;
    }

    @include tablet {
      padding-bottom: 0;
    }

    @include phone {
      padding-bottom: 20px;
    }

    &-actions {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  &__toggle-map {
    display: flex;
    position: relative;
    z-index: 99;
  }

  &__body {
    min-height: 280px;

    @include tablet {
      min-height: 362px;
    }

    @include phone {
      min-height: 385px;
    }

    @include phone-s {
      min-height: 372px;
    }
  }

  &__search-result {
    font-weight: 700;
    font-size: 40px;
    line-height: 48px;

    @include desktop {
      font-size: 26px;
      line-height: 37px;
    }

    @include tablet {
      font-size: 22px;
    }

    @include phone {
      font-weight: 500;
      font-size: 20px;
      line-height: 26px;
    }
  }

  &__sorting {
    position: relative;
    z-index: 99;
    flex: none;
    // width: 350px;
    // margin-left: 62px;

    @include laptop {
      // position: absolute;
      right: 0;
      width: auto;
    }
  }

  &__list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    // align-items: flex-start;

    @include phone {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  &__item {}

  &__bottom {
    position: relative;
    margin-top: 62px;

    &>* {
      padding: 16px 60px;

      @include phone {
        padding: 0;
      }
    }

    @include flex-center;

    @include laptop {
      justify-content: space-between;
      margin-top: 32px;
    }
  }

  &__btn {
    @include phone {
      height: 36px;
      font-size: 14px;
      padding: 8px 20px;
    }
  }

  &__pagination {
    position: absolute;
    right: 0;

    @include phone {
      position: static;
      margin-top: 0;
    }
  }
}
</style>